import { Component, OnInit, forwardRef, ViewChild, AfterViewInit, Input, ChangeDetectorRef, AfterContentInit, AfterContentChecked, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormGroup, AbstractControl, ValidationErrors, ControlValueAccessor, Validator, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { FormMode, CertificateTypes, Languages, ServiceStatus } from 'src/app/shared/models/enums.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AgentCertificate } from '../shared/models/agent-certificate.model';
import { AgentInfo } from '../shared/models/agent.model';
import { GenericLookup } from 'src/app/front-user/shared/models/generic-lookup.model';
import { LookupService } from 'src/app/front-user/shared/services/lookup.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { AgentService } from '../shared/services/agent.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { fileService } from 'src/app/front-user/shared/services/file.service';
import { PasswordStrengthValidator } from 'src/app/front-user/shared/validator/password-strength.validators';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { debounceTime, first } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AgentRepresentative } from '../shared/models/agent-representative.model';
import { MembershipService } from '../shared/services/membership.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { AppConfig } from 'src/app/shared/services/app.config';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
import { FileValidator } from 'src/app/front-user/shared/validator/file-input.validator';
//import { elementStyleProp } from '@angular/core/src/render3';
import { FeesEstimationService } from '../fees-estimation-request/fees-estimation.service';

@Component({
  selector: 'app-update-agent-profile',
  templateUrl: './update-agent-profile.component.html',
  styleUrls: ['./update-agent-profile.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UpdateAgentProfileComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => UpdateAgentProfileComponent),
      multi: true
    }
  ]
})
export class UpdateAgentProfileComponent implements OnInit, ControlValueAccessor, Validator, AfterViewInit {

  userNameError: any = { isError: false, errorMessage: '' };
  showRequest = false;
  formSubmitted: boolean = false;
  updateAgentForm: FormGroup;
  @ViewChild('updateAgentTabs',{static: false}) updateAgentTabs: TabsetComponent;
  loggedInUser: User = new User();
  error: any = { isError: false, errorMessage: '' };
  genericLookupModel: GenericLookup[] = [];
  public agentInfo: AgentInfo = new AgentInfo();

  uploadUrl = AppConfig.settings.apiServer.UploadsUrl;

  uploadFolder = AppConfig.settings.apiServer.EBookingUploadsFolder;
  public updatedAgentInfo: AgentInfo = new AgentInfo();
  dropdownSettings = {};
  selectedItems = [];
  public agentCertificate: AgentCertificate[] = [];
  ShippingProgress: number;
  TaxCardProgress: number;
  taxCardAppendixProgress: number;
  taxAuthorizationProgress: number;
  commercialRecordProgress: number;
  otherDocumentsProgress: number;
  CertificateDate: Date;
  agentId: string = '';
  licensingsShipping: AgentCertificate = new AgentCertificate();
  taxCard: AgentCertificate = new AgentCertificate();
  taxCardAppendix: AgentCertificate = new AgentCertificate();
  taxAuthorization: AgentCertificate = new AgentCertificate();
  commercialRecord: AgentCertificate = new AgentCertificate();
  otherDocuments: AgentCertificate = new AgentCertificate();

  private agentRep: AgentRepresentative[] = [];

  private responseObj: ResponseObject = new ResponseObject();
  public CertificateTypes: any = CertificateTypes;

  numberRegex: string = '^[0-9]*$';
  public
  prLanguages: any = Languages;
  baseRequestId: string;
  public FormMode: any = FormMode;
  formMode = FormMode.Edit;
  user: User = new User();
  agent: User = new User();
  responseObject: ResponseObject;
  agentIdFound: boolean = false;
  @Input() public AgentId: string;
  @Input() public RequestStatus: number;
  ServiceStatus = ServiceStatus;
  baseRequestDTO: BaseRequest;
  requestStatus: any;
  moreInformation: any;
  @ViewChild('tabOne',{static: false}) tabOneControls: ElementRef;
  @ViewChild('tabTwo',{static: false}) tabTwoControls: ElementRef;
  @ViewChild('tabThree',{static: false}) tabThreeControls: ElementRef;
  isTabOneSubmitted: boolean = false;
  isTabTwoSubmitted: boolean = false;
  isTabTwoValid: boolean = true;
  isTabOneValid: boolean = true;
  @ViewChild('updateAgent',{static: false}) updateAgent: ElementRef;
  emailRegex: string = '^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]+(\\.)[a-zA-Z0-9-.]+$';

  @Input() IsAdminMode: boolean = false;
  isErrorMessage: boolean = false;
  isCompleted: boolean = false;
  displayedLang: Languages;

  showHeader: boolean = false;
  DuplicateNationalId: boolean = false;
  DuplicateUserName: boolean = false;
  AgentRepList: any;
  AgentCurrencyList: any;
  constructor(private lookupService: LookupService,
    private translate: TranslateService, private fileService: fileService,
    private route: ActivatedRoute, private agentService: AgentService, private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private alertService: AlertService, private authenticationService: AuthenticationService,
    private agentSrv: AgentService, private baseRequestService: BaseRequestService,
    private membershipService: MembershipService, private cd: ChangeDetectorRef,
    private feesEstimationService: FeesEstimationService,
    private router: Router, ) {
    this.displayedLang = this.globalSrv.getLanguage();
    this.loggedInUser = this.authenticationService.currentUserValue;
    this.buildForm();
    this.user = this.authenticationService.currentUserValue;
    if (history.state.data && history.state.data.requestId) {
      this.agentIdFound = true;
      this.baseRequestId = history.state.data.requestId;
      if (!this.user.IsAdmin) {
        this.showHeader = true;
      }
      else {
        this.showHeader = false;
      }
      this.getBaseRequest();


    } else {
      this.CheckCanApplyFees();
    }

  }

  getBaseRequest() {
    this.baseRequestService.getBaseRequest(this.baseRequestId).subscribe(
      d => {
        this.baseRequestDTO = d.Data;
        this.requestStatus = this.baseRequestDTO.StatusId;
        this.agentId = this.baseRequestDTO.RequestorId;
        if (history.state.data && history.state.data.isCompleted) {
          this.updateAgentForm.disable();
          this.formMode = FormMode.Readonly;
        }

        else if (this.requestStatus == ServiceStatus.PendingonRegistrationAdminApproval && this.user.IsAdmin) {
          this.formMode = FormMode.Readonly;
          this.updateAgentForm.disable();
          this.updateAgentForm.get('agentCertificate').enable();
        }

        else if (this.requestStatus == ServiceStatus.MoreInformationRequestedFromAgent && this.user.UserId == this.agentId) {
          this.formMode = FormMode.Edit;
          this.updateAgentForm.enable();
        }
        else {
          this.formMode = FormMode.Readonly;
          this.updateAgentForm.disable();
        }
        this.editAgent(this.agentId);
        this.getASPUser(this.agentId);

      }
    )
  }

  getASPUser(agentId) {
    this.membershipService.GetAspUser(agentId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObject = resObj;
        if (this.responseObject.Success) {
          this.agent.UserName = resObj.Data['Email'];
          this.agent.Password = resObj.Data['Password'];
          this.agent.ConfrimPassword = resObj.Data['Password'];
          this.agent.RegisterTypeId = resObj.Data['BaseUser'].RegistrationTypeId;
          // console.log("Success");
        }
        else {
          // console.log("Fail");
        }
      });
  }


  ngOnInit() {
    this.globalSrv.isLoaderEnabled = true;


    this.dropdownSettings = {
      singleSelection: false,
      idField: 'Id',
      textField: this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN',
      selectAllText: this.translate.instant('FRONT_USER.SELECT_ALL'),
      unSelectAllText: this.translate.instant('FRONT_USER.UN_SELECT_ALL'),
      allowSearchFilter: true
    };

    this.lookupService.getCurrencies()
      .subscribe((data: ResponseObject) => {
        this.genericLookupModel = data.Data as GenericLookup[];
      });

  }

  ngAfterViewInit(): void {
    this.cd.detectChanges();
    this.globalSrv.isLoaderEnabled = false;
  }


  buildForm() {
    this.updateAgentForm = this.formBuilder.group({
      name: new FormControl('', [Validators.required, CustomValidators.textSpaceValidator()]),
      displayName: new FormControl('', [Validators.required, CustomValidators.textSpaceValidator()]),
      address: new FormControl('', [Validators.required, CustomValidators.textSpaceValidator()]),
      phone1: new FormControl('', [Validators.required, Validators.pattern(this.numberRegex)]),
      phone2: new FormControl('', Validators.pattern(this.numberRegex)),
      fax: new FormControl('', [Validators.required, Validators.pattern(this.numberRegex), CustomValidators.textSpaceValidator()]),
      contactPerson: new FormControl('', [Validators.required, CustomValidators.textSpaceValidator()]),

      agentCurrency: new FormGroup({
        currencyId: new FormControl('', Validators.required)
      }),

      agentCertificate: new FormGroup({
        licensingsShippingUrl: new FormControl('', FileValidator.validate),
        shippingExpirationDate: new FormControl('', [Validators.required, CustomValidators.dateValidator()]),
        licensingsShippingId: new FormControl(''),
        taxCardUrl: new FormControl('', FileValidator.validate),
        taxCardExpirationDate: new FormControl('', [Validators.required, CustomValidators.dateValidator()]),
        taxCardId: new FormControl(''),
        taxCardAppendixUrl: new FormControl(''),
        taxCardAppendixExpirationDate: new FormControl('', CustomValidators.dateValidator()),
        taxCardAppendixId: new FormControl(''),
        taxAuthorizationUrl: new FormControl('', FileValidator.validate),
        taxAuthorizationExpirationDate: new FormControl('', [Validators.required, CustomValidators.dateValidator()]),
        taxAuthorizationId: new FormControl(''),
        commercialRecordUrl: new FormControl('', FileValidator.validate),
        commercialRecordExpirationDate: new FormControl('', [Validators.required, CustomValidators.dateValidator()]),
        commercialRecordId: new FormControl(''),
        otherDocumentsUrl: new FormControl(''),
        otherDocumentsExpirationDate: new FormControl('', CustomValidators.dateValidator()),
        otherDocumentsId: new FormControl(''),
      }),
      agentRepresentative: this.formBuilder.array([]),

    });

  }
  addRepresentative() {
    let control = <FormArray>this.updateAgentForm.controls['agentRepresentative'];
    control.push(new FormGroup({
      username: new FormControl('', [Validators.required, Validators.pattern(this.emailRegex)]),
      password: new FormControl('', [Validators.required, Validators.minLength(8), PasswordStrengthValidator]),
      nationalId: new FormControl('', [Validators.required, Validators.pattern(/^(\d{14})$/)]),
      UserId: new FormControl('')
    }));
  }

  get agentRepresentative() {
    return this.updateAgentForm.get('agentRepresentative') as FormArray;
  }

  get f() {
    return this.updateAgentForm.controls;
  }
  //#region CVA starts

  public onTouched: () => void = () => { };

  writeValue(val: any): void {
    val && this.updateAgentForm.setValue(val, { emitEvent: false });
  }
  registerOnChange(fn: any): void {
    this.updateAgentForm.valueChanges.subscribe(fn);
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.updateAgentForm.disable() : this.updateAgentForm.enable();
  }
  registerOnValidatorChange(fn: () => void): void {
    this.updateAgentForm.statusChanges.subscribe(fn);
  }
  validate(c: AbstractControl): ValidationErrors | null {
    //return this.agentForm.valid ? null : { invalidForm: {valid: false, message: "agent form fields are invalid"}};
    return this.updateAgentForm.valid ? null : this.updateAgentForm.controls;
  }
  //#endregion

  public onFileSelected(event, certType: number, progressVariableName) {
    this[progressVariableName] = 0;
    let percentDone = 0;
    this.alertService.clear();
    var formControlName = event.target.attributes['formControlName'].value;
    if (!this.fileService.IsFileExtentionValid(event)) {
      this.updateAgentForm.controls['agentCertificate'].get(formControlName).setValue("");
      this.translate.get('FRONT_USER.NotAllowedFileExtentionMessage').subscribe((res: string) => {
        this.alertService.error(res);
        let invalidElements = document.getElementsByClassName('alert-danger');
        event.target.value = "";
        window.scrollTo(0, 0);
        return false;
      });
    }

    else if (!this.fileService.IsFileSizeValid(event)) {
      this.updateAgentForm.controls['agentCertificate'].get(formControlName).setValue("");
      this.translate.get('FRONT_USER.NotAllowedFileSize').subscribe((res: string) => {
        this.alertService.error(res);
        let invalidElements = document.getElementsByClassName('alert-danger');
        event.target.value = "";
        window.scrollTo(0, 0);
        return false;
      });

    }
    else {
      const file = event.target.files[0];
      const formData = new FormData();
      formData.append('File', file);
      let donName = file.name.split('.').slice(0, -1).join('.')
      formData.append('DocumentName', donName);

      formData.append('FolderName', this.uploadFolder); //New Line
      this.fileService.fileUploader(formData).subscribe(
        event => {

          if (event.type === HttpEventType.UploadProgress) {
            // This is an upload progress event. Compute and show the % done:
            percentDone = Math.round(100 * event.loaded / event.total)

            // console.log(`File is ${percentDone}% uploaded.`);

            this[progressVariableName] = percentDone;

            this.updateAgentForm.controls['agentCertificate'].get(formControlName).setErrors({ notCompleted: true });
          } else if (event instanceof HttpResponse) {

            var jsonResponse = event.body.Data;
            var Url = jsonResponse.Url;
            // console.log("json resp:" + jsonResponse);
            var certificate = new AgentCertificate();
            certificate.URL = Url;
            certificate.NameAR = file.name;
            certificate.NameEN = file.name;
            certificate.CertificateType = certType;
            certificate.Size = file.size;
            if (this.formMode == FormMode.Edit) {
              certificate.Id = this.setCertificateIds(certType);
              if (!certificate.Id) {
                this.updatedAgentInfo.AgentCertificates = this.updatedAgentInfo.AgentCertificates.filter(h => h.CertificateType !== certType);
                this.updatedAgentInfo.AgentCertificates.push(certificate);
              } else {
                this.updatedAgentInfo.AgentCertificates.forEach((key: any, vals: any) => {
                  if (key.Id == certificate.Id) {
                    key.URL = certificate.URL
                    key.NameAR = certificate.NameAR
                    key.NameEN = certificate.NameEN
                    key.CertificateType = certificate.CertificateType
                    key.Size = certificate.Size
                  }
                });
              }
            }
            this.updateAgentForm.controls['agentCertificate'].get(formControlName).setErrors(null);
            this.updateAgentForm.controls['agentCertificate'].get(formControlName).updateValueAndValidity();
          }
        }

      );

    }
  }

  onChangeUserName(event, control) {

    let UserName = event.target.value;
    // let controls = this.updateAgentForm.get('agentRepresentative') as FormArray;
    this.membershipService.DuplicateUser(UserName).pipe(debounceTime(1000)).subscribe((data: ResponseObject) => {
      if (!data.Success) {
        control.setErrors({ duplicatedNumber: true });
      }
      else {
        control.setErrors(null);
        control.setValidators([Validators.required, Validators.pattern(this.emailRegex)]);
        control.updateValueAndValidity();
      }
    });
  }

  setCertificateIds(certificateType) {
    if (certificateType === CertificateTypes.shippingLicensing) {
      return this.licensingsShipping.Id;
    }
    if (certificateType === CertificateTypes.TaxAuthorization) {
      return this.taxAuthorization.Id;
    }
    if (certificateType === CertificateTypes.Taxcard) {
      return this.taxCard.Id;
    }
    if (certificateType === CertificateTypes.OtherDocuments && this.otherDocuments) {
      return this.otherDocuments.Id;
    }
    if (certificateType === CertificateTypes.Taxcardappendix && this.taxCardAppendix) {
      return this.taxCardAppendix.Id;
    }
    if (certificateType === CertificateTypes.CommercialRecord) {
      return this.commercialRecord.Id;
    }
  }


  public editAgent(agentId: string) {
    this.agentService.GetAgent(agentId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.isTabOneValid = true;
          this.isTabTwoValid = true;
          this.AgentRepList = resObj.Data['AgentRepresentatives'];
          this.AgentCurrencyList = resObj.Data['AgentCurrencies'];
          this.moreInformation = resObj.Data['MoreInformation'];
          if (history.state.data && history.state.data.isCompleted) {
            if (this.moreInformation) {
              this.isCompleted = true;
            }
          }
          else if (this.moreInformation && this.loggedInUser.IsAdmin && this.requestStatus == ServiceStatus.PendingonRegistrationAdminApproval) {
            this.isCompleted = true;
          }
          if (this.displayedLang == Languages.Arabic) {
            this.updateAgentForm.patchValue({
              name: resObj.Data['Name'],
              displayName: resObj.Data['DisplayName'],
              address: resObj.Data['Address'],
              phone1: resObj.Data['Phone1'],
              phone2: resObj.Data['Phone2'],
              fax: resObj.Data['Fax'],
              contactPerson: resObj.Data['ContactPerson'],
              agentCurrency: {
                currencyId:
                  resObj.Data['AgentCurrencies'].map(function (obj) {
                    return {
                      Id: obj.Currency.Id,
                      NameAR: obj.Currency.NameAR,
                      AgentCurrencyId: obj.Id
                    }
                  }),
              }
            });
          }
          else {
            this.updateAgentForm.patchValue({
              name: resObj.Data['Name'],
              displayName: resObj.Data['DisplayName'],
              address: resObj.Data['Address'],
              phone1: resObj.Data['Phone1'],
              phone2: resObj.Data['Phone2'],
              fax: resObj.Data['Fax'],
              contactPerson: resObj.Data['ContactPerson'],
              agentCurrency: {
                currencyId:
                  resObj.Data['AgentCurrencies'].map(function (obj) {
                    return {
                      Id: obj.Currency.Id,
                      NameEN: obj.Currency.NameEN,
                      AgentCurrencyId: obj.Id
                    }
                  }),
              }
            });
          }
          let element: HTMLElement = document.getElementsByTagName('Html')[0] as HTMLElement;
          element.click();
          var formGroup = this.updateAgentForm.get("agentCertificate") as FormGroup;
          this.licensingsShipping = this.returnCertificates(resObj.Data['AgentCertificates'], CertificateTypes.shippingLicensing);
          this.taxCard = this.returnCertificates(resObj.Data['AgentCertificates'], CertificateTypes.Taxcard);
          this.taxCardAppendix = this.returnCertificates(resObj.Data['AgentCertificates'], CertificateTypes.Taxcardappendix);
          this.taxAuthorization = this.returnCertificates(resObj.Data['AgentCertificates'], CertificateTypes.TaxAuthorization);
          this.commercialRecord = this.returnCertificates(resObj.Data['AgentCertificates'], CertificateTypes.CommercialRecord);
          this.otherDocuments = this.returnCertificates(resObj.Data['AgentCertificates'], CertificateTypes.OtherDocuments);

          formGroup["controls"]["shippingExpirationDate"].setValue(new Date(this.licensingsShipping.ExpirationDate));
          formGroup["controls"]["licensingsShippingId"].setValue(this.licensingsShipping.Id);

          formGroup["controls"]["taxCardExpirationDate"].setValue(new Date(this.taxCard.ExpirationDate));
          formGroup["controls"]["taxCardId"].setValue(this.taxCard.Id);
          if (this.taxCardAppendix) {
            formGroup["controls"]["taxCardAppendixExpirationDate"].setValue(new Date(this.taxCardAppendix.ExpirationDate));
            formGroup["controls"]["taxCardAppendixId"].setValue(this.taxCardAppendix.Id);

          }

          //var formGroup = this.agentForm.get("agentCertificate") as FormGroup;
          formGroup["controls"]["taxAuthorizationExpirationDate"].setValue(new Date(this.taxAuthorization.ExpirationDate));
          formGroup["controls"]["taxAuthorizationId"].setValue(this.taxAuthorization.Id);
          //var formGroup = this.agentForm.get("agentCertificate") as FormGroup;
          formGroup["controls"]["commercialRecordExpirationDate"].setValue(new Date(this.commercialRecord.ExpirationDate));
          formGroup["controls"]["commercialRecordId"].setValue(this.commercialRecord.Id);
          //var formGroup = this.agentForm.get("agentCertificate") as FormGroup;
          if (this.otherDocuments) {
            formGroup["controls"]["otherDocumentsExpirationDate"].setValue(new Date(this.otherDocuments.ExpirationDate));
            formGroup["controls"]["otherDocumentsId"].setValue(this.otherDocuments.Id);
          }
          if (this.formMode == FormMode.Edit) {
            formGroup["controls"]["licensingsShippingUrl"].clearValidators();
            formGroup["controls"]["licensingsShippingUrl"].updateValueAndValidity();
            formGroup["controls"]["taxCardUrl"].clearValidators();
            formGroup["controls"]["taxCardUrl"].updateValueAndValidity();
            formGroup["controls"]["taxAuthorizationUrl"].clearValidators();
            formGroup["controls"]["taxAuthorizationUrl"].updateValueAndValidity();
            formGroup["controls"]["commercialRecordUrl"].clearValidators();
            formGroup["controls"]["commercialRecordUrl"].updateValueAndValidity();

            this.updatedAgentInfo.AgentCertificates.push(this.licensingsShipping);
            this.updatedAgentInfo.AgentCertificates.push(this.taxCard);
            this.updatedAgentInfo.AgentCertificates.push(this.taxAuthorization);
            this.updatedAgentInfo.AgentCertificates.push(this.commercialRecord);
            if (this.taxCardAppendix) {
              this.updatedAgentInfo.AgentCertificates.push(this.taxCardAppendix);
            }
            if (this.otherDocuments) {

              this.updatedAgentInfo.AgentCertificates.push(this.otherDocuments);
            }
          }
          this.updateAgentForm.setControl('agentRepresentative', this.getRepresentative(resObj.Data['AgentRepresentatives']));

        }

      });

  }

  getRepresentative(agentRepresentatives): any {
    let control = <FormArray>this.updateAgentForm.controls['agentRepresentative'];
    if ((this.requestStatus == ServiceStatus.MoreInformationRequestedFromAgent && this.user.UserId == this.agentId) || this.formMode == FormMode.Edit) {
      agentRepresentatives.forEach((key) => {
        control.push(new FormGroup({
          username: new FormControl({ value: key.UserName, disabled: true }),
          password: new FormControl({ value: key.Password, disabled: true }),
          nationalId: new FormControl({ value: key.NationalId, disabled: false }),
          UserId: new FormControl({ value: key.UserId, disabled: false }),
        }));
      });
    }
    else {
      agentRepresentatives.forEach((key) => {
        control.push(new FormGroup({
          username: new FormControl({ value: key.UserName, disabled: true }),
          password: new FormControl({ value: key.Password, disabled: true }),
          nationalId: new FormControl({ value: key.NationalId, disabled: true }),
          UserId: new FormControl({ value: key.UserId, disabled: false }),
        }));
      });
    }
    return control;
  }

  returnCertificates(agentCertificates, certType: number): AgentCertificate {
    let certificate = null;
    agentCertificates.forEach((key) => {
      if (key.CertificateType == certType) {
        certificate = new AgentCertificate();
        certificate.ExpirationDate = key.ExpirationDate;
        certificate.URL = key.URL;
        certificate.NameEN = key.NameEN;
        certificate.NameAR = key.NameAR;
        certificate.Id = key.Id;
        certificate.CertificateType = certType;
      }

    });
    return certificate;
  }
  selectTab(tabId: number) {

    if (tabId == 1) {
      this.isTabOneSubmitted = true;
      this.isTabOneValid = false;
      if (!this.validateTabTwo) {
        this.isTabOneValid = true;
        this.updateAgentTabs.tabs[tabId].disabled = false;
        this.updateAgentTabs.tabs[tabId].active = true;
        this.updateAgentTabs.tabs[tabId + 1].disabled = true;
        this.updateAgentTabs.tabs[tabId + 1].active = false;
        const el = document.getElementsByClassName('section-title');
        el[0].scrollIntoView({ behavior: 'smooth' });
      }
      else {
        const invalidControls = this.tabOneControls.nativeElement.querySelectorAll('.ng-invalid');
        if (invalidControls.length > 0) {
          invalidControls[0].focus();
        }
      }

    }
    else if (tabId == 2) {
      //Tab Two Controls Valid
      this.isTabTwoSubmitted = true;
      this.isTabTwoValid = false;
      if (this.getValidity()) {
        this.isTabTwoValid = true;
        this.updateAgentTabs.tabs[tabId].disabled = false;
        this.updateAgentTabs.tabs[tabId].active = true;
        const el = document.getElementsByClassName('sectionTitle');
        el[0].scrollIntoView({ behavior: 'smooth' });
      } else {
        const invalidControls = this.tabTwoControls.nativeElement.querySelectorAll('.ng-invalid');
        if (invalidControls.length > 0) {
          invalidControls[0].focus();
        }
      }
    } else {
      this.updateAgentTabs.tabs[tabId].disabled = false;
      this.updateAgentTabs.tabs[tabId].active = true;
    }
  }

  getValidity() {
    let controls = this.updateAgentForm.get('agentRepresentative') as FormArray;
    if (controls.invalid) {
      this.isTabTwoValid = false;
    }
    else {
      this.isTabTwoValid = true;
    }
    return !controls.invalid;

  }

  get validateTabTwo() {
    const isvalid = this.updateAgentForm.controls['name'].invalid
      || this.updateAgentForm.controls['displayName'].invalid
      || this.updateAgentForm.controls['address'].invalid
      || this.updateAgentForm.controls['phone1'].invalid
      || this.updateAgentForm.controls['phone2'].invalid
      || this.updateAgentForm.controls['fax'].invalid
      || this.updateAgentForm.controls['contactPerson'].invalid
      || this.updateAgentForm.get('agentCurrency').invalid;
    if (isvalid) {
      this.isTabOneValid = false;
    }
    else {
      this.isTabOneValid = true;
    }
    return isvalid;


  }
  onChangeNational(event, control, userId) {
    let nationalId = event.target.value;
    if (control.valid && !userId.value) {
      this.agentService.CheckNationalId(nationalId).subscribe((data: ResponseObject) => {
        if (!data.Success) {
          control.setErrors({ duplicatedNumber: true });
        }
        else {
          control.setErrors(null);
          control.setValidators([Validators.required, Validators.pattern(/^(\d{14})$/)]);
          control.updateValueAndValidity();
        }
      });
    }
    else if (control.valid && userId.value) {
      this.agentService.CheckUpdateNationalId(nationalId, userId.value).subscribe((data: ResponseObject) => {
        if (!data.Success) {
          control.setErrors({ duplicatedNumber: true });
        }
        else {
          control.setErrors(null);
          control.setValidators([Validators.required, Validators.pattern(/^(\d{14})$/)]);
          control.updateValueAndValidity();
        }
      });
    }
    else {
      control.setErrors(null);
      control.setValidators([Validators.required, Validators.pattern(/^(\d{14})$/)]);
      control.updateValueAndValidity();

    }
  }

  deleteRepresentative(index: number) {
    this.agentRepresentative.removeAt(index);
    this.responseObj.Data['AgentRepresentatives'].splice(index, 1);
  }


  onSubmit() {

    // nashwa validation focus
    // const invalidElements = this.namefield.nativeElement.querySelectorAll('.ng-invalid');
    // if (invalidElements.length > 0) {
    //   invalidElements[0].focus();
    // }
    this.alertService.clear();
    const invalidElements = this.updateAgent.nativeElement.querySelectorAll('.ng-invalid');
    if (invalidElements.length > 0) {
      invalidElements[0].focus();
      if (this.validateTabTwo) {
        this.navigateToTab(0);

      }
      if (!this.getValidity()) {
        this.navigateToTab(1);

      }
      else {
        this.navigateToTab(2);

      }
    }
    this.formSubmitted = true;
    // stop here if form is invalid
    if (this.updateAgentForm.invalid) {
      return;
    }


    this.globalSrv.isLoaderEnabled = true;
    this.agent.UserId = this.agentId;
    this.agent.Agent.Name = this.updateAgentForm.controls.name.value;
    this.agent.Agent.DisplayName = this.updateAgentForm.controls.displayName.value;
    this.agent.Agent.Address = this.updateAgentForm.controls.address.value;
    this.agent.Agent.Phone1 = this.updateAgentForm.controls.phone1.value;
    this.agent.Agent.Phone2 = this.updateAgentForm.controls.phone2.value;
    this.agent.Agent.Fax = this.updateAgentForm.controls.fax.value;
    this.agent.Agent.ContactPerson = this.updateAgentForm.controls.contactPerson.value;

    this.agent.Agent.AgentCurrencies = this.updateAgentForm.controls.agentCurrency.value.currencyId.map(function (obj) {
      return {
        CurrencyId: obj.Id,
        Id: obj.AgentCurrencyId
      }
    });
    this.agentRep = this.updateAgentForm.controls.agentRepresentative.value.map(function (obj) {
      return {
        UserName: obj.username,
        Password: obj.password,
        NationalId: obj.nationalId,
        UserId: obj.UserId
      }
    });

    this.agent.Agent.AgentRepresentatives = this.agentRep;
    //   this.agent.Agent.AgentRepresentatives.reduce((acc, obj)=> {
    //     var existItem = acc.find(item => item.UserName === obj.UserName);
    //     if(existItem) {

    //         this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.DuplicateUserName'), false);
    //         return;
    //     }
    //     var existItem = acc.find(item => item.NationalId === obj.NationalId);
    //     if(existItem) {

    //       this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.DuplicateNationalId'), false);
    //       return;
    //   }
    //     acc.push(obj);
    //     return acc;
    // }, []);

    this.agent.Agent.AgentCertificates = this.updatedAgentInfo.AgentCertificates;
    this.agent.Agent.AgentCertificates = this.agent.Agent.AgentCertificates.filter(item => item.URL != "");

    let dateNow = new Date();
    this.agent.Agent.AgentCertificates.forEach((key: any, vals: any) => {
      if (key.CertificateType == CertificateTypes.shippingLicensing && this.updateAgentForm.controls.agentCertificate.value.shippingExpirationDate) {
        var selectedshippingtDate = this.updateAgentForm.controls.agentCertificate.value.shippingExpirationDate.toLocaleString('en-US');
        key.ExpirationDate = selectedshippingtDate;

      }
      if (key.CertificateType == CertificateTypes.Taxcard && this.updateAgentForm.controls.agentCertificate.value.taxCardExpirationDate) {
        var selectedTaxcardtDate = this.updateAgentForm.controls.agentCertificate.value.taxCardExpirationDate.toLocaleString('en-US');
        key.ExpirationDate = selectedTaxcardtDate;

      }
      if (key.CertificateType == CertificateTypes.Taxcardappendix && this.updateAgentForm.controls.agentCertificate.value.taxCardAppendixExpirationDate) {
        var selectedTaxcardtAppendixDate = this.updateAgentForm.controls.agentCertificate.value.taxCardAppendixExpirationDate.toLocaleString('en-US');
        key.ExpirationDate = selectedTaxcardtAppendixDate;

      }
      if (key.CertificateType == CertificateTypes.TaxAuthorization && this.updateAgentForm.controls.agentCertificate.value.taxAuthorizationExpirationDate) {
        var selectedTaxAuthDate = this.updateAgentForm.controls.agentCertificate.value.taxAuthorizationExpirationDate.toLocaleString('en-US');
        key.ExpirationDate = selectedTaxAuthDate;

      }
      if (key.CertificateType == CertificateTypes.CommercialRecord && this.updateAgentForm.controls.agentCertificate.value.commercialRecordExpirationDate) {
        var selectedCommercialRecordDate = this.updateAgentForm.controls.agentCertificate.value.commercialRecordExpirationDate.toLocaleString('en-US');
        key.ExpirationDate = selectedCommercialRecordDate;
      }
      if (key.CertificateType == CertificateTypes.OtherDocuments && this.updateAgentForm.controls.agentCertificate.value.otherDocumentsExpirationDate) {
        var selectedOtherDocumentsDate = this.updateAgentForm.controls.agentCertificate.value.otherDocumentsExpirationDate.toLocaleString('en-US');
        key.ExpirationDate = selectedOtherDocumentsDate;
      }

      this.agent.Agent.AgentCertificates = this.agent.Agent.AgentCertificates.filter(item => item.URL != '' && item.ExpirationDate);

    })

    if (this.requestStatus == ServiceStatus.MoreInformationRequestedFromAgent) {
      this.agent.RequestId = this.baseRequestDTO.Id;
      this.agentSrv.UpdateProfileNextStep(this.agent)
        .pipe(first())
        .subscribe(
          (data: ResponseObject) => {
            this.responseObject = data;
            if (this.responseObject.Success) {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = false;
              this.updateAgentForm.reset();
            }
            else if (data.ErrorMessages.find(e => e == "DuplicateNationalId") != null) {
              this.globalSrv.isLoaderEnabled = false;
              this.DuplicateNationalId = true;
              this.showRequest = true;
            }
            else if (data.ErrorMessages.find(e => e == "DuplicateUserName") != null) {
              this.globalSrv.isLoaderEnabled = false;
              this.DuplicateUserName = true;
              this.showRequest = true;
            }
            else {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = true;
              //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + this.responseObject.ErrorMessages[0]), false);

            }

          });
    }
    else {


      this.agentSrv.UpdateProfile(this.agent)
        .pipe(first())
        .subscribe(
          (data: ResponseObject) => {
            this.responseObject = data;
            if (this.responseObject.Success) {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = false;
              this.updateAgentForm.reset();
            } else if (data.ErrorMessages.find(e => e == "DuplicateNationalId") != null) {
              this.globalSrv.isLoaderEnabled = false;
              this.DuplicateNationalId = true;
              this.showRequest = true;
            }
            else if (data.ErrorMessages.find(e => e == "DuplicateUserName") != null) {
              this.globalSrv.isLoaderEnabled = false;
              this.DuplicateUserName = true;
              this.showRequest = true;
            }
            else {
              this.globalSrv.isLoaderEnabled = false;
              this.showRequest = true;
              this.isErrorMessage = true;
              //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + this.responseObject.ErrorMessages[0]), false);

            }

          });
    }
  }


  reduce(agentRep) {
    let res = this.AgentRepList;
    agentRep.map(function (item) {
      var existItem = res.find(x => x.UserName == item.UserName);
      if (existItem) {
        this.globalSrv.isLoaderEnabled = false;
        this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.DuplicateUserName'));
        return;
      }
      else {
        res.push(item);
      }
    });

    // var areAnyDuplicates = false;

    // this.agentRep.map(function (obj) {
    //   return obj.UserName;
    // }).forEach(function (element, index, arr) {
    //   if (arr.indexOf(element) !== index) {
    //     areAnyDuplicates = true;
    //     this.globalSrv.isLoaderEnabled = false;
    //     this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.DuplicateUserName'));
    //     window.scrollTo(0,0)
    //     return;
    //   }
    // });
  }



  navigateToTab(tabId: number) {
    this.updateAgentTabs.tabs[tabId].disabled = false;
    this.updateAgentTabs.tabs[tabId].active = true;
  }

  getValidityControl(index) {
    return (<FormArray>this.updateAgentForm.get('agentRepresentative')).controls[index].invalid;
  }

  CheckCanApplyFees() {
    this.agentSrv.CanApplyUpdateAgentProfile(this.loggedInUser.UserName).pipe(first())
      .subscribe(
        (data: ResponseObject) => {
          if (!data.Success) {
            this.router.navigate(['/unAuhtorized']);
          } else {
            this.formMode = FormMode.Edit;
            this.isTabOneValid = true;
            this.isTabTwoValid = true;
            this.agentId = this.user.UserId;
            this.updateAgentForm.enable();
            this.editAgent(this.agentId);
            this.getASPUser(this.agentId);
          }
        });
  }


  onValueChange(value: Date, control): void {
    if (value) {
      control.setValidators(CustomValidators.dateValidator());
      control.updateValueAndValidity();
    } else {
      control.setValue('');
      control.clearValidators();
      control.updateValueAndValidity();
    }

  }

  onItemDeSelect($event) {
    this.alertService.clear();
    let currencyId = $event.Id;
    this.agentService.getAgentCurrency(this.agentId, currencyId).pipe(first())
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.feesEstimationService.getAll(this.agent.UserName).subscribe((result: ResponseObject) => {
              if (result.Data) {
                let data = result.Data.filter(p => p.SelectedCurrencyId == currencyId);
                if (data.length > 0) {
                  this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.AlreadyHaveCurrencyRequest'));
                  window.scrollTo(0, 0);
                  if (this.displayedLang == Languages.Arabic) {
                    this.updateAgentForm.patchValue({
                      agentCurrency: {
                        currencyId:
                          this.AgentCurrencyList.map(function (obj) {
                            return {
                              Id: obj.Currency.Id,
                              NameAR: obj.Currency.NameAR,
                              AgentCurrencyId: obj.Id
                            }
                          }),
                      }
                    });
                  }
                  else {
                    this.updateAgentForm.patchValue({
                      agentCurrency: {
                        currencyId:
                          this.AgentCurrencyList.map(function (obj) {
                            return {
                              Id: obj.Currency.Id,
                              NameEN: obj.Currency.NameEN,
                              AgentCurrencyId: obj.Id
                            }
                          }),
                      }
                    });
                  }

                  let element: HTMLElement = document.getElementsByTagName('Html')[0] as HTMLElement;
                  element.click();
                }
              }
            });


          }

        });
  }

  onItemSelect($event) {
    this.alertService.clear();
  }

}
